import axios from "@/plugins/axios.js";
import store from "@/store";
// state
export const state = {
  showDrawer: false,
  categoriesProducts: [],
  mainAddons: [],
  optionsAddons: [],
};

// mutations
export const mutations = {
  SET_SOW_DRAWER: (state, data) => {
    state.showDrawer = data;
  },
  SET_CATEGORIES_PRODUCTS: (state, data) => {
    state.categoriesProducts = data;
  },
  SET_MAIN_ADDONS: (state, data) => {
    state.mainAddons = data;
  },
  SET_OPTIONS_ADDONS: (state, data) => {
    state.optionsAddons = data;
  },
};

// actions
export const actions = {
  setShowDrawer({ commit }, payload) {
    commit("SET_SOW_DRAWER", payload);
  },
  async setLoadCategoriesProducts({ commit }) {
    store.dispatch("loading/start");
    const { data } = await axios.get(
      "/app/store/" + store.getters.storeIdAdmin + "/productcategories"
    );
    commit("SET_CATEGORIES_PRODUCTS", data.data);
    store.dispatch("loading/done");
  },
  async setLoadMainAddons({ commit }) {
    store.dispatch("loading/start");
    const { data } = await axios.get(
      "/admin/store/" + store.getters.storeIdAdmin + "/menus/mainAddons"
    );
    commit("SET_MAIN_ADDONS", data.data);
    store.dispatch("loading/done");
  },
  async setLoadOptionsAddons({ commit }) {
    store.dispatch("loading/start");
    const { data } = await axios.get(
      "/admin/store/" + store.getters.storeIdAdmin + "/menus/subAddons"
    );
    commit("SET_OPTIONS_ADDONS", data.data);
    store.dispatch("loading/done");
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
